import tDynamic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tDynamic'
import type {
  ReviewTag,
  SummarizationTag,
} from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuReviews/types'

/**
 * Теги суммаризации для чипсов над списком.
 *
 * Без `translit` тег не фильтрует выдачу — такие пункты отбрасываются.
 */
export default function mapReviewsTags(
  tags: SummarizationTag[],
  activeTranslit?: string,
): ReviewTag[] {
  return tags
    .filter(tag => Boolean(tag.translit))
    .map(tag => ({
      name: tDynamic(tag, 'name') || tag.name,
      translit: tag.translit,
      isActive: Boolean(activeTranslit) && tag.translit === activeTranslit,
      countTotalRates: tag.count_total_rates ?? 0,
      countLikedRates: tag.count_liked_rates ?? 0,
      countDislikedRates: tag.count_disliked_rates ?? 0,
    }))
}
